import React from 'react';
import Icon from '../../../components/AppIcon';
import { formatDate } from '../../../utils/formatters';

const QuickFactsSidebar = ({ conference, onSubmitClick }) => {
  return (
    <div className="space-y-4 md:space-y-6">
      <div className="bg-card border border-border rounded-lg shadow-elevation-2 p-4 md:p-6">
        <h3 className="text-base md:text-lg font-semibold text-foreground mb-4">Contact Information</h3>
        
        <div className="space-y-3">
          <a
            href={`mailto:${conference?.contactEmail}`}
            className="flex items-center gap-3 p-3 rounded-lg hover:bg-muted transition-all duration-250"
          >
            <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name="Mail" size={16} className="text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs text-muted-foreground caption">Email</p>
              <p className="text-sm font-medium text-foreground truncate">{conference?.contactEmail}</p>
            </div>
          </a>

          {conference?.contactPhone && (
            <a
              href={`tel:${conference?.contactPhone}`}
              className="flex items-center gap-3 p-3 rounded-lg hover:bg-muted transition-all duration-250"
            >
              <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Icon name="Phone" size={16} className="text-primary" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs text-muted-foreground caption">Phone</p>
                <p className="text-sm font-medium text-foreground">{conference?.contactPhone}</p>
              </div>
            </a>
          )}

          {conference?.website && (
            <a
              href={conference?.website}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 p-3 rounded-lg hover:bg-muted transition-all duration-250"
            >
              <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Icon name="Globe" size={16} className="text-primary" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs text-muted-foreground caption">Website</p>
                <p className="text-sm font-medium text-foreground truncate">Visit Website</p>
              </div>
            </a>
          )}
        </div>
      </div>
      {/* TODO: Stay Updated and Share Conference sections - add later */}
    </div>
  );
};

export default QuickFactsSidebar;